import React from "react";
import Layout from "../containers/layout";
import SEO from "../components/seo"

import { graphql } from 'gatsby'
import BasePortableText from '@sanity/block-content-to-react'

export const query = graphql`
  {
    site: sanityAlgemeneVoorwaarden(_id: {regex: "/(drafts.|)algemeneVoorwaarden/"}) {
      _rawBody(resolveReferences: {maxDepth: 5})
    }
  }
`

class AlgemeneVoorwaarden extends React.Component {
  constructor(queryData) {
    super(queryData);
    const {data} = queryData;

    this.data = data;
  }
  render() {
    return(
      <Layout>
        <SEO title="Algemene Voorwaarden" />
        <section className="content-block">
          <div className="wrap">
            <div className="row">
              <div className="col-lg-9">
                <BasePortableText blocks={this.data.site._rawBody}/>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

export default AlgemeneVoorwaarden
